import React from "react";
import { Link } from "react-router-dom";

const ITEMS = [
  { id: "escrow", title: "Escrow Integration", body: "Hold investor deposits and originated principal in licensed third-party escrow for added counter-party protection." },
  { id: "calculator", title: "Advanced Yield Calculator", body: "Multi-scenario amortization with default-rate distributions, recovery curves, and IRR / MIRR / Sharpe-ratio outputs." },
  { id: "valuation", title: "Note Valuation Engine", body: "Mark-to-market every secondary-market note using comparable-pricing models and live payment performance." },
  { id: "watchlist", title: "Watchlist Notifications", body: "Email + in-app alerts when new notes hit the marketplace matching your saved yield, grade, and state filters." },
  { id: "dealer", title: "Dealer Accounts", body: "Open the origination marketplace to multi-seller dealer networks with admin oversight and KYC." },
  { id: "ratings", title: "Investor Ratings", body: "Earn a rating based on funding history. Higher-rated investors get earlier access to premium tier-A originations." },
  { id: "diligence", title: "Automated Due-Diligence Packages", body: "One-click bundles with title, lien, insurance, VIN, and credit verification per note." },
  { id: "transfer", title: "Electronic Note Transfer", body: "Digital signatures + e-recording on secondary-market transfers so notes change hands without paperwork." },
];

export default function ComingSoon() {
  return (
    <div data-testid="page-coming-soon" className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="border-b border-border pb-6 mb-10">
        <div className="font-overline text-accent">Roadmap</div>
        <h1 className="font-display text-5xl mt-2">Coming Soon</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">
          Features in the active roadmap. Want one prioritized? <Link to="/legal#legal-contact" className="underline">Get in touch</Link>.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-border border border-border">
        {ITEMS.map((i) => (
          <section key={i.id} id={i.id} data-testid={`coming-${i.id}`} className="bg-background p-8 scroll-mt-24">
            <div className="font-overline text-accent">Roadmap</div>
            <h2 className="font-display text-2xl mt-2">{i.title}</h2>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{i.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
